import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './styles/style.css';
import { App } from './App.jsx';
import { installNativeBack } from './lib/nativeBack.js';

// 안드로이드 하드웨어 뒤로 가기(DEV-12): 껍데기가 window.__insaengBack 을 부름
installNativeBack();

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>
);
